import React, { useState } from 'react';
import SupportRequestList from './admin/SupportRequestList';
import SupportChat from './admin/SupportChat';
import './SupportChatManagement.css';

interface SupportRequest {
  id: number;
  requesterId: number;
  requesterName: string;
  requesterPhone: string;
  requesterEmail: string;
  subject: string;
  description: string;
  category: string;
  priority: string;
  status: string;
  requestedAt: string;
  aiConversationHistory?: Array<{
    role: 'user' | 'assistant';
    content: string;
    timestamp?: string;
  }>;
  hasAiHistory: boolean;
  chatRoomRoomId?: string;
  assignedAdminId?: number;
  assignedAdminName?: string;
}

const SupportChatManagement: React.FC = () => {
  const [activeView, setActiveView] = useState<'list' | 'chat'>('list');
  const [selectedRequest, setSelectedRequest] = useState<SupportRequest | null>(null);

  const handleOpenChat = (request: SupportRequest) => {
    if (request.chatRoomRoomId) {
      setSelectedRequest(request);
      setActiveView('chat');
    } else {
      alert('No chat room available for this request');
    }
  };

  const handleBackToList = () => {
    setActiveView('list');
    setSelectedRequest(null);
  };

  return (
    <div className="support-chat-management">
      {activeView === 'list' && (
        <SupportRequestList onOpenChat={handleOpenChat} />
      )}
      {activeView === 'chat' && selectedRequest && selectedRequest.chatRoomRoomId && (
        <SupportChat
          requestId={selectedRequest.id}
          roomId={selectedRequest.chatRoomRoomId}
          onBack={handleBackToList}
        />
      )}
    </div>
  );
};

export default SupportChatManagement;
